export const homepageClarityTranslations = {
  en: {
    items: [
      { label: "What is Marstick?", text: "A daily maritime decision assistant for weather, planning, learning, and safer skipper choices." },
      { label: "Who is it for?", text: "Sailors, skippers, and boat owners who want a clearer go/no-go view before departure." },
      { label: "Why register?", text: "Save your boat, sailing areas, watchlists, alerts, and personalized daily skipper briefing." },
    ],
    startText: "Start with today’s go/no-go view, then save the areas and routes you watch most.",
    cta: "Create skipper profile",
  },
  he: {
    items: [
      { label: "מה זה Marstick?", text: "עוזר שייט מבוסס AI למזג אוויר, תכנון, למידה והחלטות בטוחות יותר." },
      { label: "למי זה מתאים?", text: "לשייטים חובבים, סקיפרים ובעלי סירות שרוצים ביטחון לפני כל הפלגה." },
      { label: "למה להירשם?", text: "שמרו את הסירה, המסלולים, ההתראות, היסטוריית ההפלגות והתדריך הימי היומי האישי." },
    ],
    startText: "התחילו מתצוגת לצאת/לא לצאת של היום, ואז בנו את פרופיל הקפטן האישי שלכם.",
    cta: "צרו פרופיל קפטן",
  },
  es: {
    items: [
      { label: "¿Qué es Marstick?", text: "Un asistente náutico con IA para meteorología, planificación, aprendizaje y decisiones más seguras." },
      { label: "¿Para quién es?", text: "Para navegantes recreativos, patrones y propietarios que quieren confianza antes de cada salida." },
      { label: "¿Por qué registrarse?", text: "Guarda tu barco, rutas, alertas, historial de travesías y briefing marino diario personalizado." },
    ],
    startText: "Empieza con la vista de salir/no salir de hoy y luego crea tu perfil personal de capitán.",
    cta: "Crear perfil de capitán",
  },
  it: {
    items: [
      { label: "Cos’è Marstick?", text: "Un assistente nautico AI per meteo, pianificazione, apprendimento e decisioni più sicure." },
      { label: "Per chi è?", text: "Per velisti, skipper e proprietari che vogliono più fiducia prima di ogni uscita." },
      { label: "Perché registrarsi?", text: "Salva barca, rotte, avvisi, storico viaggi e briefing marino giornaliero personalizzato." },
    ],
    startText: "Inizia dalla vista partire/non partire di oggi, poi crea il tuo profilo capitano personale.",
    cta: "Crea profilo capitano",
  },
  fr: {
    items: [
      { label: "Qu’est-ce que Marstick ?", text: "Un compagnon nautique IA pour la météo, la planification, l’apprentissage et des décisions plus sûres." },
      { label: "Pour qui ?", text: "Pour plaisanciers, skippers et propriétaires qui veulent plus de confiance avant chaque sortie." },
      { label: "Pourquoi s’inscrire ?", text: "Enregistrez bateau, routes, alertes, historique de navigation et briefing marin quotidien personnalisé." },
    ],
    startText: "Commencez avec la vue départ/non-départ du jour, puis créez votre profil capitaine personnel.",
    cta: "Créer un profil capitaine",
  },
  de: {
    items: [
      { label: "Was ist Marstick?", text: "Ein KI-Bootsassistent für Wetter, Planung, Lernen und sicherere Entscheidungen." },
      { label: "Für wen ist es?", text: "Für Freizeitsegler, Skipper und Bootseigner, die vor jedem Törn mehr Sicherheit wollen." },
      { label: "Warum registrieren?", text: "Speichere Boot, Routen, Warnungen, Törnhistorie und dein personalisiertes tägliches Seebriefing." },
    ],
    startText: "Starte mit der heutigen Go/No-Go-Ansicht und erstelle dann dein persönliches Kapitänsprofil.",
    cta: "Kapitänsprofil erstellen",
  },
  pt: {
    items: [
      { label: "O que é a Marstick?", text: "Uma assistente náutica com IA para meteorologia, planejamento, aprendizagem e decisões mais seguras." },
      { label: "Para quem é?", text: "Para velejadores recreativos, skippers e proprietários que querem confiança antes de cada viagem." },
      { label: "Por que se registrar?", text: "Salve seu barco, rotas, alertas, histórico de viagens e briefing marítimo diário personalizado." },
    ],
    startText: "Comece pela visão sair/não sair de hoje e depois crie seu perfil pessoal de capitão.",
    cta: "Criar perfil de capitão",
  },
  ar: {
    items: [
      { label: "ما هي Marstick؟", text: "رفيق قوارب ذكي للطقس والتخطيط والتعلّم واتخاذ قرارات أكثر أمانًا." },
      { label: "لمن هي؟", text: "للبحّارة الترفيهيين والربابنة ومالكي القوارب الذين يريدون ثقة قبل كل رحلة." },
      { label: "لماذا التسجيل؟", text: "احفظ قاربك ومساراتك وتنبيهاتك وسجل رحلاتك والموجز البحري اليومي المخصص." },
    ],
    startText: "ابدأ بعرض الانطلاق/عدم الانطلاق لليوم، ثم أنشئ ملف القبطان الشخصي.",
    cta: "إنشاء ملف القبطان",
  },
  el: {
    items: [
      { label: "Τι είναι το Marstick;", text: "Ένας AI βοηθός σκαφών για καιρό, σχεδιασμό, μάθηση και ασφαλέστερες αποφάσεις." },
      { label: "Για ποιον είναι;", text: "Για ερασιτέχνες ιστιοπλόους, skippers και ιδιοκτήτες σκαφών που θέλουν σιγουριά πριν από κάθε ταξίδι." },
      { label: "Γιατί εγγραφή;", text: "Αποθηκεύστε σκάφος, διαδρομές, ειδοποιήσεις, ιστορικό ταξιδιών και εξατομικευμένο ημερήσιο ναυτικό briefing." },
    ],
    startText: "Ξεκινήστε με τη σημερινή εικόνα go/no-go και μετά δημιουργήστε το προσωπικό προφίλ καπετάνιου.",
    cta: "Δημιουργία προφίλ καπετάνιου",
  },
  ru: {
    items: [
      { label: "Что такое Marstick?", text: "AI-помощник для лодки: погода, планирование, обучение и более безопасные решения." },
      { label: "Для кого это?", text: "Для яхтсменов-любителей, шкиперов и владельцев лодок, которым нужна уверенность перед каждым выходом." },
      { label: "Зачем регистрироваться?", text: "Сохраняйте лодку, маршруты, оповещения, историю переходов и персональный ежедневный морской брифинг." },
    ],
    startText: "Начните с сегодняшнего решения выходить/не выходить, затем создайте личный профиль капитана.",
    cta: "Создать профиль капитана",
  },
  tr: {
    items: [
      { label: "Marstick nedir?", text: "Hava durumu, planlama, öğrenme ve daha güvenli kararlar için AI tekne asistanı." },
      { label: "Kimler için?", text: "Her seyirden önce güven isteyen amatör denizciler, kaptanlar ve tekne sahipleri için." },
      { label: "Neden kayıt olmalı?", text: "Teknenizi, rotalarınızı, uyarılarınızı, seyir geçmişinizi ve kişisel günlük deniz brifinginizi kaydedin." },
    ],
    startText: "Bugünün çık/çıkma görünümüyle başlayın, sonra kişisel kaptan profilinizi oluşturun.",
    cta: "Kaptan profili oluştur",
  },
  zh: {
    items: [
      { label: "Marstick 是什么？", text: "面向天气、规划、学习和更安全决策的 AI 船艇助手。" },
      { label: "适合谁使用？", text: "适合希望每次出航前更有信心的休闲水手、船长和船主。" },
      { label: "为什么注册？", text: "保存你的船只、航线、提醒、航行历史和个性化每日海事简报。" },
    ],
    startText: "从今天的出航/不出航视图开始，然后建立你的个人船长档案。",
    cta: "创建船长档案",
  },
};

export function getHomepageClarityCopy(language) {
  return homepageClarityTranslations[language] || null;
}